// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"249":"a3b3652d","453":"96453769"}[chunkId] + ".chunk.js";
};